import React from "react";
import { Typography, Box, Divider } from "@material-ui/core";
import imgAutomaticDebit from "../../assets/img/debito-automatico.svg";
import imgHiddenDebt from "../../assets/img/hiddenDebtIcon_white.png";
import imgWaitingApro from "../../assets/img/exclamation-mark.svg";
import imgIPTU from "../../assets/img/iptu.svg";
import imgITIV from "../../assets/img/icone_itiv.png";
import imgEmpty from "../../assets/img/icon-empty.png";
import imgTL from "../../assets/img/tff.svg";
import imgDefault from "../../assets/img/geral.svg";

import { useStyles, Stamp } from "./styles";
import { cga, imoveis } from "../../helper/formatersMask";

function ListDebit(props) {
  const classes = useStyles();
  const hasCota = validatePropCota(props.contentCard.Parcela);
  const hasExercicio = validatePropAnoExercicio(props.contentCard.AnoExercicio);
  const { selectionModeActive, handleClickSelect, handleClickOpen } = props;
  const [state] = React.useState({
    idItem: false,
  });

  function validatePropCota(cota) {
    if (cota !== null && cota !== undefined && cota !== "") {
      return true;
    } else {
      return false;
    }
  }

  function validatePropAnoExercicio(exercicio) {
    if (
      exercicio !== null &&
      exercicio !== undefined &&
      exercicio !== "" &&
      exercicio !== 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  function renderIconeCards(Codigo) {
    switch (Codigo) {
      case "IMOVEL":
        return <img src={imgIPTU} alt="IPTU" style={{ width: "25px" }} />;
      case "ESTABELECIMENTO":
        return <img src={imgTL} alt="TL/TRSD" className={classes.imgIco} />;
      case "ITIV":
        return <img src={imgITIV} style={{ width: "23px" }} alt="ITIV" />;
      default:
        return (
          <img
            src={imgDefault}
            alt="Icone default"
            className={classes.imgIco}
          />
        );
    }
  }


  function rederNumInscricao (numInscricao, tipoDebito) {
    if(tipoDebito === "IMOVEL")
      return imoveis(numInscricao);
    return cga(numInscricao);
  }

  function renderStatusDataDebito(cardContent) {
    var date = new Date();
    var hoje = new Date(date.getFullYear(),date.getMonth(), date.getDate());

    let partsDataVencimentoDiaUtil = null;
    let partsDataVencimento = cardContent.DataVencimento?.split('/') 

    if (cardContent.DataVencimentoDiaUtil === null) {
      cardContent.DataVencimentoDiaUtil = cardContent.DataVencimento;
      partsDataVencimentoDiaUtil = cardContent.DataVencimentoDiaUtil?.split("/");
    } else
      partsDataVencimentoDiaUtil = cardContent.DataVencimentoDiaUtil?.split("-");

    var DataVencimento = new Date(partsDataVencimento[2], partsDataVencimento[1] -1 , partsDataVencimento[0])
    var DataVencimentoDiaUtil = new Date(partsDataVencimentoDiaUtil[0], partsDataVencimentoDiaUtil[1] - 1, partsDataVencimentoDiaUtil[2] !== undefined ? partsDataVencimentoDiaUtil[2].substring(0,2) : null )
  
    if (cardContent.CodigoSituacao === "Q")
      return <Stamp color="#7bb94e" label="Pago" />;

    if (
      hoje.valueOf() >= DataVencimento.valueOf() &&
      hoje.valueOf() <= DataVencimentoDiaUtil.valueOf()
    )
      return <Stamp color="#ffa700" label="Vence Hoje" />;
      
    if (
      hoje.valueOf() >= DataVencimento.valueOf() &&
      hoje.valueOf() >= DataVencimentoDiaUtil.valueOf()
    )
      return <Stamp color="#d82929" label="Vencido" />;
  }
  
  return (
    <div
      className={`${classes.list} ${state.idItem && classes.cardSelected}`}
      onClick={selectionModeActive ? handleClickSelect : handleClickOpen}
    >
      {props.contentCard.Contribuinte !== null &&
      props.contentCard.Tributo !== null &&
      props.contentCard.DataVencimentoConvertida !== "31/12/1969" ? (
        <div className={classes.infoContent}>
          <div className={classes.textList}>
            <div className={classes.indicadorDam}>
              {props.contentCard.IndicadoresDAM !== null &&
                props.contentCard.IndicadoresDAM !== undefined && (
                  <img
                    src={imgWaitingApro}
                    className={classes.IndicatorIcon}
                    alt="Indicando que possui DAM"
                  />
                )}
            </div>
            <div className={classes.nomeDebito}>
              {renderIconeCards(props.contentCard.Tributo.Icone)}
              <Typography
                style={{
                  display: "flex",
                  marginBottom: "0px",
                  marginLeft: "10px",
                }}
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                {props.contentCard.Tributo.Nome}
              </Typography>
              <div className={`${classes.center} ${classes.stampContainer}`}>
                {renderStatusDataDebito(props.contentCard)}
              </div>
            </div>

            {(props.contentCard.Solicitacao === null ||
              props.contentCard.Solicitacao === undefined) && (
              <div className={classes.ajusteLabel}>
                <Typography
                  style={{ display: "flex" }}
                  className={classes.pos}
                  color="textSecondary"
                >
                  <Divider orientation="vertical" variant="middle" flexItem />
                  {props.contentCard.DataVencimentoConvertida}
                </Typography>
              </div>
            )}

            {props.contentCard.Solicitacao !== null && (
              <Box display="flex" alignItems="end">
                <img
                  src={imgAutomaticDebit}
                  className={classes.automaticDebitIcon}
                  alt="Calendário Indicando que possui débito automático"
                />
                <Box>
                  <span className={`${classes.quota} ${classes.quotaTitle}`}>
                    {props.contentCard.Solicitacao.opCotas === 1 ? (
                      <span>Cota Unica</span>
                    ) : (
                      <span>Cotas</span>
                    )}
                  </span>
                  <span className={`${classes.quota} ${classes.quotaDate}`}>
                    Débito automático em:{" "}
                    {props.contentCard.Solicitacao.DataVencimentoConvertida}
                  </span>
                </Box>
              </Box>
            )}

            {hasCota && hasExercicio && (
              <Typography
                className={` ${classes.descriptionDebit} ${classes.ajusteLabelCota}`}
                color="textSecondary"
              >
                <Divider orientation="vertical" variant="middle" flexItem />
                {props.contentCard.Parcela}/{props.contentCard.AnoExercicio}
              </Typography>
            )}
            {!hasCota && hasExercicio && (
              <Typography
                className={` ${classes.descriptionDebit} ${classes.ajusteLabel}`}
                color="textSecondary"
              >
                <Divider orientation="vertical" variant="middle" flexItem />{" "}
                Exercício: {props.contentCard.AnoExercicio}
              </Typography>
            )}
            {!hasCota && !hasExercicio && (
              <Typography
                className={` ${classes.descriptionDebit} ${classes.ajusteLabel}`}
                color="textSecondary"
              >
                &nbsp;
              </Typography>
            )}
            {props.contentCard.Contribuinte !== null && (
              <Typography
                className={` ${classes.descriptionDebit} ${classes.ajusteLabel}`}
                color="textSecondary"
              >
                <Divider orientation="vertical" variant="middle" flexItem />
                {rederNumInscricao(props.contentCard.Contribuinte.NumInscricaoFormatado, props.contentCard.Tributo.Icone)}
              </Typography>
            )}
            <div className={classes.ajusteLabelEndereco}>
              <Divider orientation="vertical" variant="middle" flexItem />
              {props.contentCard.Contribuinte !== null &&
                props.contentCard.Contribuinte.EnderecoFormatado !== null &&
                props.contentCard.Contribuinte.EnderecoFormatado !==
                  undefined && (
                  <Typography
                    className={` ${classes.descriptionDebit}`}
                    color="textSecondary"
                  >
                    {props.contentCard.Contribuinte.EnderecoFormatado}
                  </Typography>
                )}
              {props.contentCard.Ocultado ? (
                <div className={classes.divHiddenIcon}>
                  <img
                    src={imgHiddenDebt}
                    alt=""
                    className={classes.imgHidden}
                  />
                </div>
              ) : null}
            </div>
            {(props.contentCard.Solicitacao === null ||
              props.contentCard.Solicitacao === undefined) && (
              <div className={classes.ajusteLabelValor}>
                <Divider orientation="vertical" variant="middle" flexItem />{" "}
                <Typography variant="h6" component="h6" color="textSecondary">
                  R${" "}
                  <span className={classes.price}>
                    {props.contentCard.ValorPagarVirgula}
                  </span>
                </Typography>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={classes.center}>
          <img
            src={imgEmpty}
            alt="Sem dados para exibir"
            style={{ width: "25px" }}
          />
          <Typography
            style={{ display: "flex" }}
            className={classes.titleEmpty}
            color="textSecondary"
            gutterBottom
          >
            Não foi possível carregar os detalhes do débito
          </Typography>
        </div>
      )}
    </div>
  );
}

export const ListDebitContent = React.memo(ListDebit);
